export function setCath(key,value){
    window.localStorage.setItem(key,JSON.stringify(value))
}
export function getCache(key){
    const value = window.localStorage.getItem(key)
    if(value){
        return JSON.parse(value)
    }
    return ''
}
export function setCathString(key,value){
    window.localStorage.setItem(key,value)
}
export function getCacheString(key){
    const value = window.localStorage.getItem(key)
    if(value){
        return value
    }
    return ''
}
export function deleteCatch(key) {
    window.localStorage.removeItem(key)
}
export function clearCache(){
    window.localStorage.clear()
}
export function getToken(){
    const token = getCacheString('TOKEN');
    if(token && token != 'undefined'){
        return 'Bearer '+token
    }else {
        return ''
    }
}